import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { AppConstants } from "../constants/app.contants";
import { UserService } from "../services/user.service";
import { MicrosoftAuthService } from "../services/microsoft-auth.service";
import { LoaderService } from "../services/loader.service";

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
//#region properties
    //#endregion

    //#region ctor
    /**
     *
     */
    constructor(
        private _userService: UserService,
        private _router: Router,
        private _microsoftAuthService: MicrosoftAuthService,
        private _loaderService: LoaderService
    ) {}
    //#endregion

    //#region setters
    //#endregion

    //#region getters
    //#endregion

    //#region private actions
    //#endregion

    //#region public actions
    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        this._userService.initializeFromLocalStorage();

        if (this._userService.isUserAuthenticated) {
            return true;
        }

        this._loaderService.showLoader();
        try {
            await this._microsoftAuthService.loginWithRedirect(state.url);
            return false;
        } catch (error) {
            console.error('Microsoft auto-login failed:', error);
            this._loaderService.hideLoader();
        }

        return this._router.parseUrl(
            `/${AppConstants.ROUTES.AUTHENTICATION}/${AppConstants.ROUTES.LOGIN}?returnUrl=${encodeURIComponent(state.url)}`
        );
    }
    //#endregion
}
